import Page from '../base/Page';
import ProductSearchForm from '../components/ProductSearchForm';
import 'slick-carousel';

export default class ProductsPage extends Page {
    constructor() {
        super('.product-page');
    }

    init() {
        this.initForm();
    }

    initForm() {
        this.productSearchForm = new ProductSearchForm(this.childElements('#Form_ProductSearchForm'));
        this.productSearchForm.setProductsPage(this.element).init();
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/ProductsPage.js